export default "__VITE_ASSET__nBexPzaq__"